import React, { PureComponent } from "react";
import { Row, Col } from "reactstrap";
import axios from "axios";
import UserSearch from "./UserSearch";
import UserList from "./UserList";
import LoaderSpinner from "../../Widgets/LoaderSpinner";
import authProtection from "../../../HOCs/authProtection";
import ConfirmationModal from "../../Components/ConfirmationModal";
import withAlertTimeout from "../../../HOCs/withAlertTimeout";
import Alert from "../../Widgets/Alert";

const REMOVE_ROLE_INITIAL_STATE = {
  showConfirmationModal: false,
  userId: null,
  options: null,
  roleName: null
};

const USERS_INITIAL_STATE = {
  users: {
    allIds: [],
    byId: {}
  }
};

class Users extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...USERS_INITIAL_STATE,
      fetching: false,
      showConfirmationModal: false,
      ...REMOVE_ROLE_INITIAL_STATE
    };

    this.onSearch = this.onSearch.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);
    this.onRemoveConfirmation = this.onRemoveConfirmation.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  async onSearch(query) {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    this.setState({ fetching: true });

    try {
      const userResults = await axios.get(
        `/api/proxy/v2/users/search?query=${query}`,
        { headers }
      );

      const users = userResults.data.map(result => result.user);

      const byId = users.reduce(
        (acc, user) => ({
          ...acc,
          [user.id]: { ...user }
        }),
        {}
      );
      const allIds = users.reduce((acc, user) => [...acc, user.id], []);

      this.setState({ users: { allIds, byId }, fetching: false });
    } catch (e) {
      console.log(e);
      this.setState({ fetching: false });
    }
  }

  onRemoveClick(userId, roleName, options) {
    this.setState({ showConfirmationModal: true, userId, roleName, options });
  }

  closeModal() {
    this.setState({
      showConfirmationModal: false,
      userId: null,
      roleName: null,
      options: null
    });
  }

  onRemoveConfirmation(businessId) {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const payload = {
      name: this.state.roleName.replace(" ", "")
    };

    if (businessId) {
      payload.entityId = businessId;
    }

    axios
      .delete(`/api/proxy/v2/users/${this.state.userId}/permisgroups`, {
        data: payload,
        headers
      })
      .then(() => {
        this.props.showSuccess();
        this.setState({ ...REMOVE_ROLE_INITIAL_STATE, ...USERS_INITIAL_STATE });
      })
      .catch(err => {
        console.log(err);
        this.props.showFailure();
        this.setState(REMOVE_ROLE_INITIAL_STATE);
      });
    this.closeModal();
  }

  render() {
    return [
      <ConfirmationModal
        key="modal"
        message={"Are you sure you want to remove the user from this role?"}
        open={this.state.showConfirmationModal}
        close={this.closeModal}
        onConfirm={this.onRemoveConfirmation}
        userId={this.state.userId}
        options={this.state.options}
        roleName={this.state.roleName}
      />,
      <div key="page" className="animated fadeIn">
        {
          <Alert
            active={this.props.success}
            message="User Role Removed Successfuly"
          />
        }
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <Row>
          <Col xs="12">
            <UserSearch onSearch={this.onSearch} />
            {this.state.users.allIds.length ? (
              <UserList
                users={this.state.users}
                onRemoveClick={this.onRemoveClick}
              />
            ) : null}
            {this.state.fetching && <LoaderSpinner />}
          </Col>
        </Row>
      </div>
    ];
  }
}

export default authProtection(withAlertTimeout(Users));



// WEBPACK FOOTER //
// ./src/views/Pages/Users/Users.js